import React, { useState } from 'react';
import { Container, Row, Col, Nav, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Send } from 'lucide-react';
import logo from '../assets/JDGems_Digital_Logo.png';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  if (location.pathname.startsWith('/dashboard')) {
    return null;
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch('http://localhost:1000/api/inquiries', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setStatus({ type: 'success', message: t('footer.successMessage') });
        setFormData({ name: '', email: '', phone: '', message: '' });
        setTimeout(() => setStatus({ type: '', message: '' }), 5000);
      } else {
        throw new Error('Submission failed');
      }
    } catch (error) {
      setStatus({ type: 'danger', message: t('footer.errorMessage') });
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer id="contact" className="pt-5" style={{ backgroundColor: '#0F2854', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
      <Container className="pb-4">
        <Row className="gy-4 mb-5">
          <Col lg={4} className="pe-lg-5">
            <div className="d-flex align-items-center gap-3 text-white fw-bold fs-4 mb-4">
              <img 
                src={logo} 
                alt="JD GEMS Logo" 
                className="logo-white"
                style={{ 
                  height: '55px', 
                  width: 'auto',
                  objectFit: 'contain',
                  marginTop: '-2px'
                }} 
              />
              <span className="brand-text" style={{ 
                fontSize: '1.4rem',
                lineHeight: '1'
              }}>{t('common.brandName')}</span>
            </div>
            <p className="text-light opacity-50 small mb-4 pr-lg-4" style={{ lineHeight: '1.8' }}>
              {t('footer.aboutText')}
            </p>
          </Col>
          
          <Col lg={4}>
            <h5 className="text-white mb-4 brand-text" style={{ fontSize: '1.2rem', letterSpacing: '1px' }}>{t('footer.quickInquiry')}</h5>
            {status.message && (
              <Alert variant={status.type} className="py-2 small mb-3">
                {status.message}
              </Alert>
            )}
            <Form onSubmit={handleSubmit}>
              <Row className="g-2">
                <Col md={6}>
                  <Form.Control 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={t('footer.placeholderName')} 
                    required 
                    className="bg-transparent text-white border-secondary small py-2 custom-input"
                  />
                </Col>
                <Col md={6}>
                  <Form.Control 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={t('footer.placeholderEmail')} 
                    required 
                    className="bg-transparent text-white border-secondary small py-2 custom-input"
                  />
                </Col>
                <Col md={12}>
                  <Form.Control 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder={t('footer.placeholderPhone')} 
                    className="bg-transparent text-white border-secondary small py-2 custom-input"
                  />
                </Col>
                <Col md={12}>
                  <Form.Control 
                    as="textarea" 
                    rows={2} 
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder={t('footer.placeholderMessage')} 
                    required 
                    className="bg-transparent text-white border-secondary small py-2 custom-input"
                  />
                </Col>
              </Row>
              <Button 
                variant="primary" 
                type="submit" 
                size="sm"
                className="mt-3 w-100 d-flex align-items-center justify-content-center gap-2 premium-btn"
                disabled={loading}
              >
                {loading ? <Spinner animation="border" size="sm" /> : <Send size={14} />}
                {loading ? t('footer.sending') : t('footer.sendButton')}
              </Button>
            </Form>
          </Col>
          
          <Col lg={4} className="ps-lg-5">
            <h5 className="text-white mb-4 brand-text" style={{ fontSize: '1.2rem', letterSpacing: '1px' }}>{t('footer.contactDetails')}</h5>
            <address className="text-light opacity-50 small" style={{ lineHeight: '1.8' }}>
              <strong>Surat Office:</strong><br />
              301, Panchratna Building<br />
              Piplasheri, L B Char Rasta,<br />
              Mahidharpura, Surat-395003.<br /><br />
              <strong>Contacts:</strong><br />
              Vaibhav Parikh: +91 99137 06212<br />
              Babubhai Chothani: +91 82387 03422<br />
              Europe Contact (Shyam Chothani): +49 15202693620<br />
              Ph: 0261 2609288, Intercom: *9288<br />
              Email: shyamchothani4@gmail.com
            </address>
          </Col>
        </Row>
        
        <div className="pt-4 border-top" style={{ borderColor: 'rgba(255,255,255,0.05) !important' }}>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
              <p className="text-light opacity-50 small mb-0">&copy; {new Date().getFullYear()} {t('common.brandName')}. {t('footer.allRightsReserved')}</p>
            </Col>
            <Col md={6} className="text-center text-md-end">
              <span className="text-light opacity-50 small">{t('footer.topDiamondCompany')}</span>
            </Col>
          </Row>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
